import { useEffect, useState } from 'react';

export const useDebouncedValue = <T>(value: T, delay = 200): T => {
  const [debounced, setDebounced] = useState<T>(value);
  useEffect(() => {
    const timeoutId = window.setTimeout(() => setDebounced(value), delay);
    return () => window.clearTimeout(timeoutId);
  }, [value, delay]);
  return debounced;
};

export const useDebouncedBoolean = (value: boolean, delay = 200): boolean =>
  useDebouncedValue<boolean>(value, delay);
